export const FEATURE_NAME = '@zerops/zerops/feature/new-service-dialog';
